import type React from 'react';

import { Layout } from '../layout';

export const About: React.FC = () => {
	return <Layout />;
};
